'use client';

import { Breadcrumbs } from '@wolfejs/ui/Breadcrumbs/Breadcrumbs';
import type { UIComponentProps } from '@wolfejs/ui/types/UI';
import { cn } from '@wolfejs/ui/utils/classnames';
import { usePathname } from 'next/navigation';

export type AdminPageHeaderProps = UIComponentProps & {
  pageName?: React.ReactNode;
  breadcrumbs?: boolean;
  guideMe?: boolean;
};

export const AdminPageHeader = ({ pageName, breadcrumbs = true, guideMe = true, className }: AdminPageHeaderProps) => {
  const pathname = usePathname();
  return (
    <div className={cn('ui-dashboard-title-section flex w-full justify-between gap-4', className)}>
      <div className={cn('ui-dashboard-title-section-left flex flex-col gap-2')}>
        <div className="flex flex-1">{breadcrumbs && <Breadcrumbs pathname={pathname} />}</div>
        {pageName && <h1 className="text-default-900 dark:text-default-200 text-2xl font-bold">{pageName}</h1>}
      </div>
    </div>
  );
};
